var exports = {
  "lG": "Dialog__DZxqeo",
  "Y9": "Header__tBE2ob",
  "Eb": "ScreenReaderOnly__6CAbrh",
  "nB": "Body__DteIsy",
  "Fc": "Introduction__q-KCYb",
  "uT": "Greeting___KN9SU",
  "vM": "Welcome__Pbp763",
  "NZ": "Decoration__tws9d3",
  "lV": "Form__3_vx-E",
  "JY": "Options__e8i3gn",
  "vN": "Question__UCvVnb",
  "c$": "Option__jiTdz7",
  "sx": "Radio__zv9wSZ",
  "Nu": "OptionIcon__qaw4kV",
  "En": "Actions__fV5UKh",
  "MO": "Skip__mhEg0_",
  "XT": "Submit__oY1BRf",
};

module.exports = exports;
